import React from 'react';

import _ from 'lodash';
import { observer, useLocalObservable } from 'mobx-react';

import appStore from '@stores/app';
import ReferralProductsEdit from './ReferralProductsEdit';
import { Col, Input, Row } from 'antd';
import { deleteProduct } from '@stores/middleware/referrals';
import { EditTwoTone } from '@ant-design/icons';
import { EmTable } from '@components/EmTable';
import { Layout } from 'antd';
import { ViewHeader } from '@components/ViewHeader';

const { Content } = Layout;

const ReferralProductsView = observer(() => {
    const { categories } = appStore;

    const state = useLocalObservable(() => {
        return {
            searchText: null,
            get products() {
                return _.filter(appStore.referralProducts, campaign => campaign.name);
            },

            get filteredData() {
                return this.searchText
                    ? _.filter(this.products, item => {
                          return item?.name.match(new RegExp(this.searchText, 'gi'));
                      })
                    : this.products;
            }
        };
    });

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name'
        },
        {
            title: 'Category (subsc)',
            dataIndex: 'category'
        },
        {
            title: 'Actions',
            dataIndex: 'actions',
            // eslint-disable-next-line react/display-name
            render: (text, record) => (
                <Row>
                    <Col span={6}>
                        <ReferralProductsEdit
                            title={'Edit product details'}
                            table
                            record={record}
                            iconButton={<EditTwoTone style={{ fontSize: 20 }} twoToneColor="#eb2f96" />}
                        />
                    </Col>
                </Row>
            )
        }
    ];

    // disabled delete to avoid errors, we can edit direct in DB in case is needed
    // eslint-disable-next-line no-unused-vars
    const onDelete = value => deleteProduct(value);

    const handleChangeFilter = e => {
        state.searchText = e.target.value;
    };

    return (
        <Layout style={{ backgroundColor: '#fff' }}>
            <ViewHeader
                input={
                    <Input
                        type="text"
                        style={{ width: '44%' }}
                        allowClear
                        name="filter"
                        onChange={handleChangeFilter}
                        value={state.searchText}
                        placeholder="Filter by name..."
                    />
                }
            >
                <ReferralProductsEdit title={'Add a new product'} textButton={'Add product'} />
            </ViewHeader>
            <div style={{ color: 'red', padding: 10 }}>This will be edited by TECH team only</div>
            <Content>
                <EmTable data={state.filteredData} columns={columns} /*onDelete={onDelete}*/ />
            </Content>
        </Layout>
    );
});

export { ReferralProductsView };
